<template>
  <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" switchFullscreen
    @ok="handleOk" @cancel="handleCancel" cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form>
        <a-form-model-item prop="required" label="符合下列条件时显示">
          <a-radio-group>
            <a-radio value="1">满足全部</a-radio>
            <a-radio value="0">满足任意</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import FormBaseModal from '@views/tempconfig/modules/formmodal/FormBaseModal'
import FormExtendModal from '@views/tempconfig/modules/formmodal/FormExtendModal'
import FormAnnexModal from '@views/tempconfig/modules/formmodal/FormAnnexModal'
import { postAction } from '@/api/manage'
export default {
  name: "CsimConfigFormVisibleModal",
  components: { FormBaseModal, FormExtendModal, FormAnnexModal },
  data() {
    return {
      title: "表单显示逻辑",
      formType: "",
      model: {},
      modelFileList: { fileList: [] },
      customActiveKey: '1',
      visible: false,
      confirmLoading: false,
      url: {
        edit: "/tempconfig/tempConfigForm/edit",
      },
    }
  },

  props: {
    selectForm: {
      type: Object,
      required: true
    },
  },

  methods: {
    init() {
      console.log("Get init data for :" + this.selectForm.name);
      this.visible = true;
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      let isValid = this.$refs.formbasemodal.checkFormData();
      // // 触发表单验证
      if (isValid) {
        that.confirmLoading = true;
        let httpurl = this.url.edit;
      
        postAction(httpurl, formData).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.$emit('ok');
            that.close();
          } else {
            that.$message.warning(res.message);
          }
        }).finally(() => {
          that.confirmLoading = false;
        })
      } else {
        return false;
      }
    },
    handleCancel() {
      this.close()
    },
  }
}
</script>

<style lang="less" scoped></style>